import { render } from "./PageContent.vue?vue&type=template&id=849da44c"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
script.render = render

export default script